import { HttpErrorResponse } from '@angular/common/http';
import {
    DocumentDto,
    ExportTasksFilterState,
    ExportTasksSectionExcelData,
    TaskState,
} from '@modeso/aumico-lib-cpmm-fe';
import { FilePreviewStatus } from '@modeso/aumico-lib-cpmm-fe/enums/FilePreviewStatus.enum';
import { WorkflowArea } from '@modeso/aumico-lib-cpmm-fe/enums/workflow-area.enum';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DocumentModel } from '../../../../aumico-lib-cpmm-fe/src/lib/interfaces/document.interface';
import { ITasksExportTableHeaders } from '../dtos/tasks-export-table-headers.dto';
import { InventoryData } from '../dtos/inventory-data.dto';
import { GetOrganizationDto } from '@modeso/aumico-lib-users-fe';

export const DocumentsActions = createActionGroup({
    source: 'Documents',

    events: {
        'Load Task Documents': props<{ taskId: string }>(),
        'Load Task Documents Success': props<{ documents: DocumentDto[] }>(),
        'Load Task Documents Failure': props<{ error: any }>(),

        'Upload Document': props<{ taskId: string; files: File[]; document: Partial<DocumentModel> }>(),
        'Upload Document Success': props<{ documents: DocumentDto[] }>(),
        'Upload Document Failure': props<{ error: any }>(),

        'Update Document Metadata': props<{ document: Partial<DocumentModel> }>(),
        'Update Document Metadata Success': props<{ document: DocumentDto }>(),
        'Update Document Metadata Failure': props<{ error: any }>(),

        'Export Project Documents': props<{
            projectId: string;
            companyName: string;
            balanceSheetDate: string;
            workFlowAreas: WorkflowArea[];
            inventoryData: InventoryData;
        }>(),
        'Export Project Documents Success': props<{ blob: Blob }>(),
        'Export Project Documents Failure': props<{ error: any }>(),

        'Delete Document': props<{ documentId: string, projectId: string }>(),
        'Delete Document Success': props<{ documentId: string }>(),
        'Delete Document Failure': props<{ error: any }>(),

        'Export Tasks Excel': props<{
            payload: {
                tableHeaders: ITasksExportTableHeaders;
                data: ExportTasksSectionExcelData[];
                fileName: string;
                tasksFilter: (TaskState | ExportTasksFilterState)[];
                tableTitle: string;
                organization: GetOrganizationDto;
            };
        }>(),
        'Export Tasks Excel Success': emptyProps(),
        'Export Tasks Excel Failure': props<{ error: HttpErrorResponse }>(),

        'Check Preview Status': props<{ fileId: string }>(),
        'Check Preview Status Success': props<{ fileId: string; status: FilePreviewStatus }>(),
        'Check Preview Status Failure': props<{ fileId: string; error: any }>(),
        'Request Preview Generation': props<{ fileId: string }>(),
        'Request Preview Generation Success': props<{ fileId: string; requestId: string }>(),
        'Request Preview Generation Failure': props<{ fileId: string; error: any }>(),
        'Load Preview URL': props<{ fileId: string }>(),
        'Load Preview URL Success': props<{ fileId: string; url: string }>(),
        'Load Preview URL Failure': props<{ fileId: string; error: any }>(),

        'Open File': props<{ fileId: string }>(),
        'Open File Success': props<{ fileId: string; url: string }>(),
        'Open File Failure': props<{ fileId: string; error: any }>(),

        'Revoke File URL': props<{ fileId: string }>(),
    },
});
